<template>
<main class="container">
      <b-row>
        <!-- The Modal -->
        <div id="myModal" class="modal" >
            
            <!-- Modal content -->
            <b-col lg="12" class="modal-content" >
                
                    <img src="../assets/logo.png" class="img-fluid mx-auto" height="50px" width="150px">
                    <h4 class="mx-auto">Welcome! Please select one:</h4>
                    <button class="btn mx-auto" id="farmer" @click="setRebateType('Farmer')">I AM A FARMER</button>
                    <button class="btn mx-auto" id="integrator"  @click="setRebateType('Integrator')">I AM AN INTEGRATOR</button>
                
            </b-col>
            

        </div>
        <!-- END OF MODAL -->
      </b-row>
    <b-row>
      <b-col lg="12">
        <h4>
            <strong>Hydro Manufacturer's Rebate Center</strong>
        </h4>
      </b-col>
      <b-col col lg="12">
          <p><strong> I am a: &nbsp;</strong><strong>  &nbsp;{{rebateType}}  &nbsp;</strong>
          <b-button class="btn-change" style="display:inline-block !important" @click="changeRebateType()" >CHANGE</b-button></p>
      </b-col>
      
      <b-col class="col-12" v-if="rebateType == 'Farmer'">
          <h4><strong>AquaBlend Xtreme Swine and Poultry Farmer's Rebate Program Requirements and Limitations:</strong></h4>
      </b-col>
      <b-col class="col-12" v-if="rebateType == 'Integrator'">
          <h4><strong>AquaBlend Xtreme Swine and Poultry Integrator's Rebate Program Requirements and Limitations:</strong></h4>
      </b-col>
      
      <b-col ccol lg="12" v-if="rebateType == 'Farmer'">
          <p> The Hydro Systems® AquaBlend Xtreme $40 Rebate offer is valid on purchases of products made through December 31, 2019 for swine and poultry farmers (or horticulturists) and is available to any purchaser of Hydro AquaBlend Xtreme Injectors from any recognized/eligible Hydro distributor or dealer. This rebate offer is valid for every purchase of AquaBlend Xtremes purchased, up to a total of 10. This offer can be used by first time and/or returning customers of eligible Hydro distributors or dealers. </p>
      </b-col>
      <b-col col lg="12" v-else-if="rebateType == 'Integrator'">
          <p> The Hydro Systems® Buy 12, Get 2 Free ($550 value) AquaBlend Xtreme Rebate offer is valid on purchases of products made through December 31, 2019 for swine and poultry integrator/producers and is available to any purchaser of Hydro AquaBlend Xtreme Injectors from any recognized/eligible Hydro distributor or dealer. Other purchasers, (farmers, horticulturists) can also use this rebate offer for every set of twelve (12) AquaBlend Xtremes purchased, up to a total of 36 (providing a total of up to 6 free AquaBlend Xtremes to that purchaser). This offer can be used by first time and/or returning customers of eligible Hydro distributors or dealers. </p>
      </b-col>
      <b-col col lg="12" v-if="rebateType == 'Farmer' || rebateType == 'Integrator'">
          <h4><strong>How To Submit:</strong></h4>
      </b-col>
      <b-col ccol lg="12" v-if="rebateType == 'Farmer'">
          <p> To qualify you must complete your Hydro Systems® Online Rebate Voucher at HydroRebates.com. Please submit a scan/photo of your purchase invoice(s) to validate your purchase OR you can submit by mail. Your Hydro Systems® AquaBlend Xtreme $40 Rebate offer must be received by Hydro Rebate Headquarters within 60 days of your purchase. Rebate expires December 31, 2019. </p>
      </b-col>
      <b-col col lg="12" v-else-if="rebateType == 'Integrator'">
          <p> To qualify you must complete your Hydro Systems® Online Rebate Voucher at HydroRebates.com below. Please submit a scan/photo of your purchase invoice(s) to validate your purchase OR you can submit by mail. Your Hydro Systems® Buy 12, Get 2 Free ($550 value) AquaBlend Xtreme Rebate offer must be received by Hydro Rebate Headquarters within 60 days of your purchase. Rebate expires December 31, 2019. </p>
      </b-col>
    </b-row>
    <b-row>
        <b-col col lg="12">
            <b-form id="rebateForm" method="" data-enable-shim="true">
                <b-form-row v-if="rebateType == 'Integrator'">
                    <div class="col-sm-12 col-md-12">
                        <label for="companyName">Company Name*</label>
                        <b-input id="companyName" name="companyName" type="text" style="margin-right:20px;" v-model="companyName" required/>
                    </div>
                </b-form-row>
                <b-form-row>
                    <div class="col-sm-12 col-md-6">
                        <label for="firstName">First Name*</label>
                        <b-input id="firstName" name="firstName" type="text" style="margin-right:20px;" v-model="firstName" pattern="[a-zA-Z]" required/>
                    </div>
                    <div class="col-sm-12 col-md-6">
                        <label for="lastName">Last Name*</label>
                        <b-input id="lastName" name="lastName" type="text" style=""  v-model="lastName" required/>
                    </div>
                </b-form-row>

                <b-form-row>
                    <div class="col-sm-12 col-md-6">
                        <label for="email">Email Address*</label>
                        <b-input id="email" name="email" type="email" style="margin-right:20px"  v-model="email" required/>
                    </div>
                    <div class="col-sm-12 col-md-6">
                        <label for="phone">Phone Number*</label>
                        <b-input type="tel" :maxlength="10" id="phone" name="phone" pattern="[0-9]{3}-[0-9]{3}-[0-9]{4}"  v-model="phone" required/>
                    </div>
                </b-form-row>

                <b-form-row>
                    <div class="col-sm-12 col-md-6">
                        <label for="address1">Address Line 1*</label>
                        <b-input id="address1" name="address1" type="text" style=" margin-right:20px" v-model="address1" required/>
                    </div>
                    <div class="col-sm-12 col-md-6">
                        <label for="address2">Address Line 2</label>
                        <b-input id="address2" name="address2" type="text" style=""  v-model="address2"/>
                    </div>
                </b-form-row>

                <b-form-row>
                    <div class="col-sm-12 col-md-6">
                        <label for="city">City*</label>
                        <b-input id="city" name="city" type="text" style="margin-right:20px" v-model="city" required/>
                    </div>
                    <div class="col-sm-12 col-md-6">
                        <label for="State">State/Province*</label>
                        <b-form-select id="state" v-model="state"  required>
                            <option value="AL">Alabama</option>
                            <option value="AK">Alaska</option>
                            <option value="AZ">Arizona</option>
                            <option value="AR">Arkansas</option>
                            <option value="CA">California</option>
                            <option value="CO">Colorado</option>
                            <option value="CT">Connecticut</option>
                            <option value="DE">Delaware</option>
                            <option value="DC">District Of Columbia</option>
                            <option value="FL">Florida</option>
                            <option value="GA">Georgia</option>
                            <option value="HI">Hawaii</option>
                            <option value="ID">Idaho</option>
                            <option value="IL">Illinois</option>
                            <option value="IN">Indiana</option>
                            <option value="IA">Iowa</option>
                            <option value="KS">Kansas</option>
                            <option value="KY">Kentucky</option>
                            <option value="LA">Louisiana</option>
                            <option value="ME">Maine</option>
                            <option value="MD">Maryland</option>
                            <option value="MA">Massachusetts</option>
                            <option value="MI">Michigan</option>
                            <option value="MN">Minnesota</option>
                            <option value="MS">Mississippi</option>
                            <option value="MO">Missouri</option>
                            <option value="MT">Montana</option>
                            <option value="NE">Nebraska</option>
                            <option value="NV">Nevada</option>
                            <option value="NH">New Hampshire</option>
                            <option value="NJ">New Jersey</option>
                            <option value="NM">New Mexico</option>
                            <option value="NY">New York</option>
                            <option value="NC">North Carolina</option>
                            <option value="ND">North Dakota</option>
                            <option value="OH">Ohio</option>
                            <option value="OK">Oklahoma</option>
                            <option value="OR">Oregon</option>
                            <option value="PA">Pennsylvania</option>
                            <option value="RI">Rhode Island</option>
                            <option value="SC">South Carolina</option>
                            <option value="SD">South Dakota</option>
                            <option value="TN">Tennessee</option>
                            <option value="TX">Texas</option>
                            <option value="UT">Utah</option>
                            <option value="VT">Vermont</option>
                            <option value="VA">Virginia</option>
                            <option value="WA">Washington</option>
                            <option value="WV">West Virginia</option>
                            <option value="WI">Wisconsin</option>
                            <option value="WY">Wyoming</option>
                            <option value="AB">Alberta</option>
                            <option value="BC">British Columbia</option>
                            <option value="MB">Manitoba</option>
                            <option value="NB">New Brunswick</option>
                            <option value="NL">Newfoundland and Labrador</option>
                            <option value="NS">Nova Scotia</option>
                            <option value="NT">Northwest Territories</option>
                            <option value="NU">Nunavut</option>
                            <option value="ON">Ontario</option>
                            <option value="PE">Prince Edward Island</option>
                            <option value="QC">Quebec</option>
                            <option value="SK">Saskatchewan</option>
                            <option value="YT">Yukon</option>
                        </b-form-select>
                    </div>
                </b-form-row>
                
                <b-form-row>
                    <div class="col-sm-12 col-md-6">
                        <label for="zip">Zip/Postal Code*</label>
                        <b-input id="zip" name="zip" type="text" style=" margin-right:20px" v-model="zip" @change="isValidPostalCode" data-type="postal-code" required/>
                    </div>
                    <div class="col-sm-12 col-md-6">
                        <label for="country">Country*</label>
                        <b-form-select id="country" v-model="country"  @change="isValidPostalCode" data-type="country-code" required>
                            <option value="CA">Canada</option>
                            <option value="US">United States</option>
                        </b-form-select>
                    </div>
                </b-form-row>
                <b-row id="invoiceLabels">
                    <b-col class="col-lg-3"> 
                        Upload your proof of purchase*
                    </b-col>
                    <b-col class="col-lg-1"> 
                        Mail in?
                    </b-col>
                    <b-col class="col-lg-2"> 
                        Invoice #*
                    </b-col>
                    <b-col class="col-lg-2"> 
                        Sales Date*
                    </b-col>
                    <b-col class="col-lg-3">
                        Distributor Address*
                    </b-col>
                    
                </b-row>
                <b-form-row class="" id="invoiceUpload">
                    <b-col class="col-lg-12 invoiceRow" id="invoiceRow_0">
                    <b-row>
                        <b-col class="col-lg-3 " id="upload" style="display: inline-block">
                            
                            <!-- <label class="of-label" for="invoice">Upload your proof of purchase*</label> -->
                            <span id="file-btn" @click="checkStatus($event)" @change="checkFile($event)" class="btn btn-default btn-file">
                                UPLOAD INVOICE <p id="checkmark_0" style="position:absolute; display:none; left: .5em; top: -0.9em;"><i class="fas fa-check-circle"></i></p>
                            <b-form-file id="file_0"  class=" btn-file" plain/>
                            </span>
                            
                        </b-col>
                        <b-col class="col-lg-1 align-self-center" id="mail">
                            <!-- <label for="mail_0" class="align-self-beginning mailLabel" id="mailLabel_0" > Mail in? </label> -->
                            <b-checkbox id="mail_0" name="mail_0" />
                        </b-col>
                        <div class="col-lg-2 uploadInput upload" id="invoiceNum">
                            <!-- <label for="invoiceNumber">Invoice #</label> -->
                            <b-input id="invoiceNumber_0" :placeholder="'Invoice Number'" name="invoiceNumber_0" type="text" required/>
                        </div>
                        <div class="col-lg-2 uploadInput upload" id="invoiceDate">
                            <!-- <label for="salesDate">Sales Date</label> -->
                            <b-input type="date" id="salesDate_0" data-polyfill="all" name="salesDate_0" @blur="checkDate(0, myDate)" v-model="myDate" min="2019-10-14" max="2019-12-31"  required/>
                        </div>
                       
                        <div class="col-lg-3 uploadInput upload " id="distributor" >
                            <!-- <label for="distributor">Distributor</label> -->
                            
                                <b-form-select id="distributor_0" required>
                                    <optgroup label="">
                                        <option :value="''" selected>Please Select Distributor</option>
                                    </optgroup>
                                    <optgroup label="Ag Property Solutions LLC">
                                        <option :value="'3826 460th Avenue, Emmetsburt IA'">3826 460th Avenue, Emmetsburt IA</option>
                                    </optgroup>
                                    <optgroup label="Agri Sales Inc.">
                                        <option :value="'100 Main Street, Ceresco NE'">100 Main Street, Ceresco NE</option>
                                    </optgroup>
                                    <optgroup label="Agri Ventilation Systems, LLC">
                                        <option :value="'3101 John Wayland Highway, Dayton VA'">3101 John Wayland Highway, Dayton VA</option>
                                    </optgroup>
                                    <optgroup label="Agri-Central Sales Inc.">
                                        <option :value="'1207 E 6th Street, Huntingburg	IN'">1207 E 6th Street, Huntingburg	IN</option>
                                    </optgroup>
                                    <optgroup label="Agro and Construction Solutions">
                                        <option :value="'1207 E 6th Street, Huntingburg	IN'">1207 E 6th Street, Huntingburg	IN</option>
                                    </optgroup>
                                    <optgroup label="Agxcel LLC">
                                        <option :value="'116 East 6th Street, Kearney NE'">116 East 6th Street, Kearney NE</option>
                                    </optgroup>
                                    <optgroup label="Alaso USA Corporation">
                                        <option :value="'2655 Old Tampa Highway, Lakeland FL'">2655 Old Tampa Highway, Lakeland FL</option>
                                    </optgroup>
                                    <optgroup label="Alliance Dairy Service and Supplies">
                                        <option :value="'205 Evans Street, Caldwell ID'">205 Evans Street, Caldwell ID</option>
                                    </optgroup>
                                    <optgroup label="Alpha Poultry and Livestock">
                                        <option :value="'3350 Liberty Square Parkway, Turlock CA'">3350 Liberty Square Parkway, Turlock CA</option>
                                    </optgroup>
                                    <optgroup label="Animal Health International">
                                        <option :value="'1202 ESI Drive, Springdale AR'">1202 ESI Drive, Springdale AR</option>
                                        <option :value="'1115 Metzger Street, Red Bluff CA'">1115 Metzger Street, Red Bluff CA</option>
                                        <option :value="'630 “O” Street, Greeley CO'">630 “O” Street, Greeley CO</option>
                                        <option :value="'30408 East Highway 50, La Junta CO'">30408 East Highway 50, La Junta CO</option>
                                        <option :value="'20138 Riverside Drive, Sterling CO'">20138 Riverside Drive, Sterling CO</option>
                                        <option :value="'385 Southwest 60th Avenue, Ocala FL'">385 Southwest 60th Avenue, Ocala FL</option>
                                        <option :value="'64-1021 Mamalahoa Highway, Unit D Kamuela HI'">64-1021 Mamalahoa Highway, Unit D Kamuela HI</option>
                                        <option :value="'415 West 7th Street, Caroll IA'">415 West 7th Street, Caroll IA</option>
                                        <option :value="'1426 9th Stree Southeast, Dyersville IA'">1426 9th Stree Southeast, Dyersville IA</option>
                                        <option :value="'1117 West Main Street, Manchester IA'">1117 West Main Street, Manchester IA</option>
                                        <option :value="'120 West View Drive, Washington IA'">120 West View Drive, Washington IA</option>
                                        <option :value="'203 4th Avenue West, Twin Falls ID'">203 4th Avenue West, Twin Falls ID</option>
                                        <option :value="'706 North 4th Street, Wolcott IN'">706 North 4th Street, Wolcott IN</option>
                                        <option :value="'1210 E. Trail, Dodge City KS'">1210 E. Trail, Dodge City KS</option>
                                        <option :value="'2103 West Jones Frontage Road, Garden City KS'">2103 West Jones Frontage Road, Garden City KS</option>
                                        <option :value="'1449-A West Old Highway 40, Salina KS'">1449-A West Old Highway 40, Salina KS</option>
                                        <option :value="'1380 Minnesota, Billings MT'">1380 Minnesota, Billings MT</option>
                                        <option :value="'1522 River Drive North, Great Falls MT'">1522 River Drive North, Great Falls MT</option>
                                        <option :value="'4938 Howard Boulevard, Columbus NE'">4938 Howard Boulevard, Columbus NE</option>
                                        <option :value="'2011 South Plum Creek Parkway, Lexington NE'">2011 South Plum Creek Parkway, Lexington NE</option>
                                        <option :value="'706 21st Avenue, Unit #1, Scottsbluff NE'">706 21st Avenue, Unit #1, Scottsbluff NE</option>
                                        <option :value="'5200 East Mabry, Clovis NM'">5200 East Mabry, Clovis NM</option>
                                        <option :value="'1713 Southeast Main Street, Roswell NM'">1713 Southeast Main Street, Roswell NM</option>
                                        <option :value="'1517 Highway 54 Northeast, Guymon OK'">1517 Highway 54 Northeast, Guymon OK</option>
                                        <option :value="'2340 West Havens Avenue, Mitchell SD'">2340 West Havens Avenue, Mitchell SD</option>
                                        <option :value="'2840 Vanocker Road, Sturgis SD'">2840 Vanocker Road, Sturgis SD</option>
                                        <option :value="'8106 East I-40, Amirillo TX'">8106 East I-40, Amirillo TX</option>
                                        <option :value="'6117 Amarillo Boulevard West, Amirillo TX'">6117 Amarillo Boulevard West, Amirillo TX</option>
                                        <option :value="'810 West 7th Street, Dalhart TX'">810 West 7th Street, Dalhart TX</option>
                                        <option :value="'8857 South U.S. Highway 377, Dublin TX'">8857 South U.S. Highway 377, Dublin TX</option>
                                        <option :value="'11180 Rojas,Suite C, El Paso TX'">11180 Rojas,Suite C, El Paso TX</option>
                                        <option :value="'920 Highway 380 Bypass, Graham TX'">920 Highway 380 Bypass, Graham TX</option>
                                        <option :value="'3383 Highway 60, Hereford TX'">3383 Highway 60, Hereford TX</option>
                                        <option :value="'6295 North 2150 West, Amalga UT'">6295 North 2150 West, Amalga UT</option>
                                        <option :value="'620 S. Main Street, Spanish Fork UT'">620 S. Main Street, Spanish Fork UT</option>
                                        <option :value="'944 Cherry Street, Sumas WA'">944 Cherry Street, Sumas WA</option>
                                        <option :value="'1654 South 1st Street, Sunnyside WA'">1654 South 1st Street, Sunnyside WA</option>
                                    </optgroup>
                                    <optgroup label="Barron Supply Company">
                                        <option :value="'1621 E Division Avenue, Barron WI'">1621 E Division Avenue, Barron WI</option>
                                    </optgroup>
                                    <optgroup label="Batesville Poultry">
                                        <option :value="'1401 White Drive, Batesville AR'">1401 White Drive, Batesville AR</option>
                                    </optgroup>
                                    <optgroup label="Best Veterinary Solutions, Inc.">
                                        <option :value="'381 Northern Avenue, Millsboro DE'">381 Northern Avenue, Millsboro DE</option>
                                        <option :value="'1716 Detroit Street, Ellsworth IA'">1716 Detroit Street, Ellsworth IA</option>
                                        <option :value="'1854 East Waller Drive, Washington IN'">1854 East Waller Drive, Washington IN</option>
                                        <option :value="'325 Lakeland Drive Northeast, Willmar MN'">325 Lakeland Drive Northeast, Willmar MN</option>
                                        <option :value="'616 Andrew Hunter Road, Franklinville NC'">616 Andrew Hunter Road, Franklinville NC</option>
                                        <option :value="'1 Brenneman Circle, Mechanicsburg PA'">1 Brenneman Circle, Mechanicsburg PA</option>
                                    </optgroup>
                                    <optgroup label="Bonham Powell Hardware">
                                        <option :value="'181 West Main, Green Forest AR'">181 West Main, Green Forest AR</option>
                                    </optgroup>
                                    <optgroup label="Borders Poultry Supply">
                                        <option :value="'595 State Highway 87 South, Center TX'">595 State Highway 87 South, Center TX</option>
                                        <option :value="'2801 Westward Drive, Nacogdoches TX'">2801 Westward Drive, Nacogdoches TX</option>
                                    </optgroup>
                                    <optgroup label="Bunting and Bertrand, Inc.">
                                        <option :value="'15 Hickory Street, Franfort DE'">15 Hickory Street, Franfort DE</option>
                                    </optgroup>
                                    <optgroup label="County Line Equipment">
                                        <option :value="'53852 Audrain Lane, Vandalia MO'">53852 Audrain Lane, Vandalia MO</option>
                                    </optgroup>
                                    <optgroup label="CTB Inc.">
                                        <option :value="'611 North Higbee Street, Milford IN'">611 North Higbee Street, Milford IN</option>
                                    </optgroup>
                                    <optgroup label="Deluxe Animal Health">
                                        <option :value="'109 North C Street, Sheldon IA'">109 North C Street, Sheldon IA</option>
                                    </optgroup>
                                    <optgroup label="Dixon Poultry and Equipment">
                                        <option :value="'3528 Bernice Avenue, Russellville AR'">3528 Bernice Avenue, Russellville AR</option>
                                    </optgroup>
                                    <optgroup label="Dultmeier">
                                        <option :value="'601 West 76th Street, Davenport IA'">601 West 76th Street, Davenport IA</option>
                                        <option :value="'13808 Industrial Road, Omaha NE'">13808 Industrial Road, Omaha NE</option>
                                    </optgroup>
                                    <optgroup label="East Texas Poultry Supply">
                                        <option :value="'1592 Southview Circle, Center TX'">1592 Southview Circle, Center TX</option>
                                    </optgroup>
                                    <optgroup label="Eastern Shore Poultry">
                                        <option :value="'515 Smith Avenue, Harrington DE'">515 Smith Avenue, Harrington DE</option>
                                        <option :value="'30709 Sussex Highway, Laurel DE'">30709 Sussex Highway, Laurel DE</option>
                                        <option :value="'1510 Market Street	Pocomoke, City MD'">1510 Market Street	Pocomoke, City MD</option>
                                    </optgroup>
                                    <optgroup label="Farmer Boy Ag">
                                        <option :value="'991 County Highway 13, Keenes IL'">991 County Highway 13, Keenes IL</option>
                                        <option :value="'1133 Route 318, Waterloo NY'">1133 Route 318, Waterloo NY</option>
                                        <option :value="'500 South East St, Morral OH'">500 South East St, Morral OH</option>
                                        <option :value="'50 West Stoever Avenue, Myerstown PA'">50 West Stoever Avenue, Myerstown PA</option>
                                    </optgroup>
                                    <optgroup label="Fogco Systems">
                                        <option :value="'600 South 56th Street, Suite #9, Chandler AZ'">600 South 56th Street, Suite #9, Chandler AZ</option>
                                    </optgroup>
                                    <optgroup label="G and M Sales of DelMarva Inc.">
                                        <option :value="'8999 Ocean Highway, Delmar MD'">8999 Ocean Highway, Delmar MD</option>
                                    </optgroup>
                                    <optgroup label="G and M Sales of Eastern NC Incorporated">
                                        <option :value="'522 NC 561 West, Aulander NC'">522 NC 561 West, Aulander NC</option>
                                        <option :value="'1340 US 701 North, Elizabethtown NC'">1340 US 701 North, Elizabethtown NC</option>
                                        <option :value="'103 Industry Court, Goldsboro NC'">103 Industry Court, Goldsboro NC</option>
                                        <option :value="'645 N Sycamore Street, Rose Hill NC'">645 N Sycamore Street, Rose Hill NC</option>
                                        <option :value="'1328 US 74 West, Wadesboro NC'">1328 US 74 West, Wadesboro NC</option>
                                    </optgroup>
                                    <optgroup label="Georgia Poultry">
                                        <option :value="'7940 County Road 636, Chancellor AL'">7940 County Road 636, Chancellor AL</option>
                                        <option :value="'85 Lick Creek Road, Cullman AL'">85 Lick Creek Road, Cullman AL</option>
                                        <option :value="'19576 AL Highway 117, Ider AL'">19576 AL Highway 117, Ider AL</option>
                                        <option :value="'10560 Petrey Highway, Luverne AL'">10560 Petrey Highway, Luverne AL</option>
                                        <option :value="'6561 Highway 43, Spruce Pine AL'">6561 Highway 43, Spruce Pine AL</option>
                                        <option :value="'808 Highway 62 Spur, Berryville AR'">808 Highway 62 Spur, Berryville AR</option>
                                        <option :value="'911 S Rogers Street, Clarksville AR'">911 S Rogers Street, Clarksville AR</option>
                                        <option :value="'506 North 2nd Street, Ft. Smith AR'">506 North 2nd Street, Ft. Smith AR</option>
                                        <option :value="'124 Madison 7373, Hindsville AR'">124 Madison 7373, Hindsville AR</option>
                                        <option :value="'2285 Highway 412 West, Siloam Springs AR'">2285 Highway 412 West, Siloam Springs AR</option>
                                        <option :value="'706 West Howard Street, Live Oak FL'">706 West Howard Street, Live Oak FL</option>
                                        <option :value="'2270 Rome Road Southwest, Calhoun GA'">2270 Rome Road Southwest, Calhoun GA</option>
                                        <option :value="'175 Brantley Boulevard, Douglas GA'">175 Brantley Boulevard, Douglas GA</option>
                                        <option :value="'2216 Highway 52 East, Ellijay GA'">2216 Highway 52 East, Ellijay GA</option>
                                        <option :value="'317 North Veterans Boulevard, Glennville GA'">317 North Veterans Boulevard, Glennville GA</option>
                                        <option :value="'816 Washington Road, Lexington GA'">816 Washington Road, Lexington GA</option>
                                        <option :value="'5287 Mountain Center Plaza, Lula GA'">5287 Mountain Center Plaza, Lula GA</option>
                                        <option :value="'917 4th Avenue Northeast, Moultrie GA'">917 4th Avenue Northeast, Moultrie GA</option>
                                        <option :value="'824 East College Street, Nowden GA'">824 East College Street, Nowden GA</option>
                                        <option :value="'603 East Crusselle Street, Roberta GA'">603 East Crusselle Street, Roberta GA</option>
                                        <option :value="'5570 Highway 29 South, Royston GA'">5570 Highway 29 South, Royston GA</option>
                                        <option :value="'2117 US-45 North, Maysfield KY'">2117 US-45 North, Maysfield KY</option>
                                        <option :value="'5578 Highway 167 North, Ruston LA'">5578 Highway 167 North, Ruston LA</option>
                                        <option :value="'13014 Farm Road 1005, Exeter MO'">13014 Farm Road 1005, Exeter MO</option>
                                        <option :value="'3501 South Limit, Sedalia MO'">3501 South Limit, Sedalia MO</option>
                                        <option :value="'2510 Mississippi 15, Bay Springs MS'">2510 Mississippi 15, Bay Springs MS</option>
                                        <option :value="'880 Highway 35 South, Forest MS'">880 Highway 35 South, Forest MS</option>
                                        <option :value="'2029 Simpson Highway 49, Magee MS'">2029 Simpson Highway 49, Magee MS</option>
                                        <option :value="'11780 Highway 15 North, Philadelphia MS'">11780 Highway 15 North, Philadelphia MS</option>
                                        <option :value="'1014 Office Park Court, Summit MS'">1014 Office Park Court, Summit MS</option>
                                        <option :value="'412 Wayne Street, Waynesboro MS'">412 Wayne Street, Waynesboro MS</option>
                                        <option :value="'105 Anthony Lane, Shelbyville TN'">105 Anthony Lane, Shelbyville TN</option>
                                        <option :value="'17296 Highway 79 West, Marquez TX'">17296 Highway 79 West, Marquez TX</option>
                                        <option :value="'2308 Southeast Stallings Drive, Nacogdoches TX'">2308 Southeast Stallings Drive, Nacogdoches TX</option>
                                        <option :value="'2045 US Highway 271, Pittsburg TX'">2045 US Highway 271, Pittsburg TX</option>
                                    </optgroup>
                                    <optgroup label="Gold N Plump Inc.">
                                        <option :value="'1770 Promontory Circle, Greeley CO'">1770 Promontory Circle, Greeley CO</option>
                                        <option :value="'851 Sauk River Road, Cold Spring MN'">851 Sauk River Road, Cold Spring MN</option>
                                        <option :value="'1174 County Highway 4, Luverne MN'">1174 County Highway 4, Luverne MN</option>
                                        <option :value="'4150 2nd Street South, Saint Cloud MN'">4150 2nd Street South, Saint Cloud MN</option>
                                        <option :value="'6005 North Benton Drive, Sauk Rapids MN'">6005 North Benton Drive, Sauk Rapids MN</option>
                                    </optgroup>
                                    <optgroup label="Hog Slat">
                                        <option :value="'304 Highway 18 East, Algona IA'">304 Highway 18 East, Algona IA</option>
                                        <option :value="'305 South West Street, Bloomfield IA'">305 South West Street, Bloomfield IA</option>
                                        <option :value="'19280 Highway 30 West, Carroll IA'">19280 Highway 30 West, Carroll IA</option>
                                        <option :value="'805 Boulder Avenue, Charles City IA'">805 Boulder Avenue, Charles City IA</option>
                                        <option :value="'200 SE 4th Street, Decatur City IA'">200 SE 4th Street, Decatur City IA</option>
                                        <option :value="'140 3rd Street Northwest, Hartley IA'">140 3rd Street Northwest, Hartley IA</option>
                                        <option :value="'1112 20th Street North, Humboldt IA'">1112 20th Street North, Humboldt IA</option>
                                        <option :value="'401 Enterprise Drive Southwest, Independence IA'">401 Enterprise Drive Southwest, Independence IA</option>
                                        <option :value="'605 Greenfield Avenue, Iowa Falls IA'">605 Greenfield Avenue, Iowa Falls IA</option>
                                        <option :value="'431 5th Avenue Southwest, Le Mars IA'">431 5th Avenue Southwest, Le Mars IA</option>
                                        <option :value="'205 Eagle Avenue, Marcus IA'">205 Eagle Avenue, Marcus IA</option>
                                        <option :value="'22409 Highway 151 North, Monticello IA'">22409 Highway 151 North, Monticello IA</option>
                                        <option :value="'1201 North 2nd Ave East, Rock Rapids IA'">1201 North 2nd Ave East, Rock Rapids IA</option>
                                        <option :value="'4211 US 75 Avenue, Sioux Center IA'">4211 US 75 Avenue, Sioux Center IA</option>
                                        <option :value="'126 Prairie Road, Storm Lake IA'">126 Prairie Road, Storm Lake IA</option>
                                        <option :value="'302 South Airport Road, Washington IA'">302 South Airport Road, Washington IA</option>
                                        <option :value="'1350 West Washington Street, Pittsfiels IL'">1350 West Washington Street, Pittsfiels IL</option>
                                        <option :value="'951 7th Street, Rochelle IL'">951 7th Street, Rochelle IL</option>
                                        <option :value="'315 South Sycamore Street, Flora IN'">315 South Sycamore Street, Flora IN</option>
                                        <option :value="'621 Neptune Drive, Seneca KS'">621 Neptune Drive, Seneca KS</option>
                                        <option :value="'633 6th Street Southeast, Blooming Prairie MN'">633 6th Street Southeast, Blooming Prairie MN</option>
                                        <option :value="'710 Cory Lane, Fairmont MN'">710 Cory Lane, Fairmont MN</option>
                                        <option :value="'53908 208th Lane, Mankato MN'">53908 208th Lane, Mankato MN</option>
                                        <option :value="'810 Industrial Road, Pipestone MN'">810 Industrial Road, Pipestone MN</option>
                                        <option :value="'36281 US Highway 71, Redwood Falls MN'">36281 US Highway 71, Redwood Falls MN</option>
                                        <option :value="'519 Lincoln Road, Sauk Centre MN'">519 Lincoln Road, Sauk Centre MN</option>
                                        <option :value="'440 NC Highway 561 West, Aulander NC'">440 NC Highway 561 West, Aulander NC</option>
                                        <option :value="'7160 South Main Street, Bethel NC'">7160 South Main Street, Bethel NC</option>
                                        <option :value="'246 North NC Highway 41, Beulaville NC'">246 North NC Highway 41, Beulaville NC</option>
                                        <option :value="'221 Shady Oak Drive, Biscoe NC'">221 Shady Oak Drive, Biscoe NC</option>
                                        <option :value="'903 Southeast Boulevard, Clinton NC'">903 Southeast Boulevard, Clinton NC</option>
                                        <option :value="'2406 US Highway 701 North, Elizabethtown NC'">2406 US Highway 701 North, Elizabethtown NC</option>
                                        <option :value="'5377 US Highway 70 East, Goldsboro NC'">5377 US Highway 70 East, Goldsboro NC</option>
                                        <option :value="'454 West Bobo Newsom Highway, Hartsville NC'">454 West Bobo Newsom Highway, Hartsville NC</option>
                                        <option :value="'400 Clinton Street, Newton Grove NC'">400 Clinton Street, Newton Grove NC</option>
                                        <option :value="'615 North Sycamore Street, Rose Hill NC'">615 North Sycamore Street, Rose Hill NC</option>
                                        <option :value="'17720 US Highway 64 West, Siler City NC'">17720 US Highway 64 West, Siler City NC</option>
                                        <option :value="'810 Old Wilkesboro Road Extension, Taylorsville NC'">810 Old Wilkesboro Road Extension, Taylorsville NC</option>
                                        <option :value="'406 West Maple Street, Yadkinsville NC'">406 West Maple Street, Yadkinsville NC</option>
                                        <option :value="'203 Road D, Richland NE'">203 Road D, Richland NE</option>
                                        <option :value="'539 South Main Street, West Point NE'">539 South Main Street, West Point NE</option>
                                        <option :value="'200 North Grandview Street, Union City OH'">200 North Grandview Street, Union City OH</option>
                                        <option :value="'3231 US Highway 54, Huymon OK'">3231 US Highway 54, Huymon OK</option>
                                        <option :value="'1222 West Havens Avenue, Mitchell SD'">1222 West Havens Avenue, Mitchell SD</option>
                                    </optgroup>
                                    <optgroup label="Hostetler Sales and Construction">
                                        <option :value="'210 Kelly Road, Buffalo MO'">210 Kelly Road, Buffalo MO</option>
                                    </optgroup>
                                    <optgroup label="Huntsville Feed and Milling">
                                        <option :value="'304 Labarge Avenue, Huntsville AR'">210 Kelly Road, Buffalo MO</option>
                                    </optgroup>
                                    <optgroup label="Iowa Select Farms">
                                        <option :value="'101 North Douglas Street, Afton IA'">101 North Douglas Street, Afton IA</option>
                                        <option :value="'811 South Oak Street, Iowa Falls IA'">811 South Oak Street, Iowa Falls IA</option>
                                        <option :value="'322 Northwest 7th Street, Pocahontas IA'">322 Northwest 7th Street, Pocahontas IA</option>
                                        <option :value="'4809 U.S. 21, St. Ansgar IA'">4809 U.S. 21, St. Ansgar IA</option>
                                        <option :value="'5034 Grand Ridge Drive, West Des Moines IA'">5034 Grand Ridge Drive, West Des Moines IA</option>
                                    </optgroup>
                                    <optgroup label="Jones Poultry and Livestock Equipment">
                                        <option :value="'176 N NC 41 Highway, Beulaville NC'">176 N NC 41 Highway, Beulaville NC</option>
                                    </optgroup>
                                    <optgroup label="Kingston Construction Equipment">
                                        <option :value="'9172 Ocean Highway, Delmar MD'">176 N NC 41 Highway, Beulaville NC</option>
                                        <option :value="'1324 Ocean Highway, Pocomoke City MD'">1324 Ocean Highway, Pocomoke City MD</option>
                                    </optgroup>
                                    <optgroup label="Lange Ag Systems Inc.">
                                        <option :value="'1105 North State Street (Behind Pizza Ranch), Fairmont MN'">1105 North State Street (Behind Pizza Ranch), Fairmont MN</option>
                                        <option :value="'193 County Road 9 Northeast, Willmar MN'">193 County Road 9 Northeast, Willmar MN</option>
                                    </optgroup>
                                    <optgroup label="Marion County Feed and Farm Supply">
                                        <option :value="'801 Highway 62 West, Yellville AR'">801 Highway 62 West, Yellville AR</option>
                                    </optgroup>
                                    <optgroup label="Marydel Ag Supply">
                                        <option :value="'164 Main Street, Marydel DE'">164 Main Street, Marydel DE</option>
                                    </optgroup>
                                    <optgroup label="MMDS Manufacturing Co Inc.">
                                        <option :value="'1301 South SD Highway 37, Parkston SD'">1301 South SD Highway 37, Parkston SD</option>
                                    </optgroup>
                                    <optgroup label="Michiana Equipment">
                                        <option :value="'12865 C.R. 30, Middlebury IN'">12865 C.R. 30, Middlebury IN</option>
                                    </optgroup>
                                    <optgroup label="Motion Industries">
                                        <option :value="'611 East Int. Airport Road, Anchorage AK'">611 East Int. Airport Road, Anchorage AK</option>
                                        <option :value="'1895 Van Horn Road, Unit A, Fairbanks AK'">1895 Van Horn Road, Unit A, Fairbanks AK</option>
                                        <option :value="'824 NO 31st Street, Birmingham AL'">824 NO 31st Street, Birmingham AL</option>
                                        <option :value="'825 Lakeside Drive, Mobile AL'">825 Lakeside Drive, Mobile AL</option>
                                        <option :value="'2201 Industrial Drive, Jonesboro AR'">2201 Industrial Drive, Jonesboro AR</option>
                                        <option :value="'1809 South Elmira, Avenue Russellville AR'">1809 South Elmira, Avenue Russellville AR</option>
                                        <option :value="'5545 West Latham, Suite 5C, Phoenix AZ'">5545 West Latham, Suite 5C, Phoenix AZ</option>
                                        <option :value="'4050 East Columbia Street, Tucson AZ'">4050 East Columbia Street, Tucson AZ</option>
                                        <option :value="'2358 Cepheus Court, Bakersfield CA'">2358 Cepheus Court, Bakersfield CA</option>
                                        <option :value="'8076 Central Avenue, Newark CA'">8076 Central Avenue, Newark CA</option>
                                        <option :value="'5885 Stapleton Drive North #C312, Denver CO'">5885 Stapleton Drive North #C312, Denver CO</option>
                                        <option :value="'2923 Graneros Lane, Pueblo CO'">2923 Graneros Lane, Pueblo CO</option>
                                        <option :value="'256 Main Street East, Windsor CT'">256 Main Street East, Windsor CT</option>
                                        <option :value="'528 South Cherry Street, Wallingford CT'">528 South Cherry Street, Wallingford CT</option>
                                        <option :value="'38541 Sussex Highway, Delmar DE'">38541 Sussex Highway, Delmar DE</option>
                                        <option :value="'401 Zoo Parkway, Jacksonville FL'">401 Zoo Parkway, Jacksonville FL</option>
                                        <option :value="'1417 Massaro Boulevard, Tampa FL'">1417 Massaro Boulevard, Tampa FL</option>
                                        <option :value="'8145 Troon Circle, Suite G, Austell GA'">8145 Troon Circle, Suite G, Austell GA</option>
                                        <option :value="'415 Hamilton Crossing Road, Northwest Cartersville GA'"></option>
                                        <option :value="'5620 Carey Avenue, Davenport IA'">5620 Carey Avenue, Davenport IA</option>
                                        <option :value="'1121 Zenith Drive, Sioux City IA'">1121 Zenith Drive, Sioux City IA</option>
                                        <option :value="'4317 Challenger Way, Caldwell ID'">4317 Challenger Way, Caldwell ID</option>
                                        <option :value="'2711 Garrett Way, Pocatello ID'">2711 Garrett Way, Pocatello ID</option>
                                        <option :value="'14015 Carole Drive, Bloomington IL'">14015 Carole Drive, Bloomington IL</option>
                                        <option :value="'3483 Lonergan Drive, Rockford IL'">3483 Lonergan Drive, Rockford IL</option>
                                        <option :value="'7401 East Melton Road, Gary IN'">7401 East Melton Road, Gary IN</option>
                                        <option :value="'4410 Sam Jones Expressway, Indianapolis IN'">4410 Sam Jones Expressway, Indianapolis IN</option>
                                        <option :value="'1304 Rath Avenue, Dodge City KS'">1304 Rath Avenue, Dodge City KS</option>
                                        <option :value="'3526 Southeast 21st Street, Unit A, Topeka KS'">3526 Southeast 21st Street, Unit A, Topeka KS</option>
                                        <option :value="'3324 Gilmore Ind. Boulevard, Louisville KY'">3324 Gilmore Ind. Boulevard, Louisville KY</option>
                                        <option :value="'99 Industry Drive, Versailles KY'">99 Industry Drive, Versailles KY</option>
                                        <option :value="'906 West Orice Roth, Gonzales LA'">906 West Orice Roth, Gonzales LA</option>
                                        <option :value="'105 Enterprise Street West, Monroe LA'">105 Enterprise Street West, Monroe LA</option>
                                        <option :value="'36 Sword Street, Unit 9D, Auburn MA'">36 Sword Street, Unit 9D, Auburn MA</option>
                                        <option :value="'35 Industrial Parkway, Suite 0, Woburn MA'">35 Industrial Parkway, Suite 0, Woburn MA</option>
                                        <option :value="'8415-250 Kelso Drive, Baltimore MD'">8415-250 Kelso Drive, Baltimore MD</option>
                                        <option :value="'216 Perry Road, Bangor ME'">216 Perry Road, Bangor ME</option>
                                        <option :value="'111 Pine Tree Industrial Park, Unit A, Portland ME'">111 Pine Tree Industrial Park, Unit A, Portland ME</option>
                                        <option :value="'3321 East Cork Street, Kalamazoo MI'">3321 East Cork Street, Kalamazoo MI</option>
                                        <option :value="'1700 East Avis Drive, Madison Heights MI'">1700 East Avis Drive, Madison Heights MI</option>
                                        <option :value="'8405 Enterprise Drive, North Mountain Iron MN'">8405 Enterprise Drive, North Mountain Iron MN</option>
                                        <option :value="'2580 North Cleveland Avenue, St. Paul MN'">2580 North Cleveland Avenue, St. Paul MN</option>
                                        <option :value="'13724 Shoreline Court East, Earth City MO'">13724 Shoreline Court East, Earth City MO</option>
                                        <option :value="'628 Northwest Platte Valley Drive, Riverside MO'">628 Northwest Platte Valley Drive, Riverside MO</option>
                                        <option :value="'285 Yorkville Road East, Columbus MS'">285 Yorkville Road East, Columbus MS</option>
                                        <option :value="'2211 Cliff Gookin Boulevard, Tupelo MS'">2211 Cliff Gookin Boulevard, Tupelo MS</option>
                                        <option :value="'340 North 22nd Street, Billings MT'">340 North 22nd Street, Billings MT</option>
                                        <option :value="'3390 US Highway 12 East, Helena MT'">3390 US Highway 12 East, Helena MT</option>
                                        <option :value="'1249 Shields Road, Kernersville NC'">1249 Shields Road, Kernersville NC</option>
                                        <option :value="'1903 Godwin Avenue, Lumberton NC'">1903 Godwin Avenue, Lumberton NC</option>
                                        <option :value="'1112 South 12TH Street, Unit ,B Bismarck ND'">1112 South 12TH Street, Unit ,B Bismarck ND</option>
                                        <option :value="'1400 47th Street North, Suite D, Fargo ND'">1400 47th Street North, Suite D, Fargo ND</option>
                                        <option :value="'1952 East 12th Avenue, Columbus NE'">1952 East 12th Avenue, Columbus NE</option>
                                        <option :value="'5725 F. Street, Omaha NE'">5725 F. Street, Omaha NE</option>
                                        <option :value="'444 East Industrial Park Drive, Unit # 2, Manchester NH'">444 East Industrial Park Drive, Unit # 2, Manchester NH</option>
                                        <option :value="'141 Market Street, Unit 8, Kenilworth NJ'">141 Market Street, Unit 8, Kenilworth NJ</option>
                                        <option :value="'9A South Gold Drive, Trenton NJ'">9A South Gold Drive, Trenton NJ</option>
                                        <option :value="'3321 Matthew Avenue Northeast, Albuquerque NM'">3321 Matthew Avenue Northeast, Albuquerque NM</option>
                                        <option :value="'6180 N Hollywood Boulevard, Suite 110, Las Vegas NV'">6180 N Hollywood Boulevard, Suite 110, Las Vegas NV</option>
                                        <option :value="'704 Spice Island Drive, Sparks NV'">704 Spice Island Drive, Sparks NV</option>
                                        <option :value="'12 Jupiter Lane, Albany NY'">12 Jupiter Lane, Albany NY</option>
                                        <option :value="'25 John Glenn Drive, Suite 108, Amherst NY'">25 John Glenn Drive, Suite 108, Amherst NY</option>
                                        <option :value="'10823 Joslyn Drive, Cincinnati OH'">10823 Joslyn Drive, Cincinnati OH</option>
                                        <option :value="'1666 Integrity Drive, East Columbus OH'">1666 Integrity Drive, East Columbus OH</option>
                                        <option :value="'13685 East 61st Street, Broken Arrow OK'">13685 East 61st Street, Broken Arrow OK</option>
                                        <option :value="'4116 Will Rogers Parkway, Suite 800, Oklahoma City OK'">4116 Will Rogers Parkway, Suite 800, Oklahoma City OK</option>
                                        <option :value="'2468 Southwest Ferry Street, Albany OR'">2468 Southwest Ferry Street, Albany OR</option>
                                        <option :value="'2705 Northwest Nicolai Street, Portland OR'">2705 Northwest Nicolai Street, Portland OR</option>
                                        <option :value="'1514 Parkway View Drive, Pittsburgh PA'">1514 Parkway View Drive, Pittsburgh PA</option>
                                        <option :value="'301 Henderson Drive, Sharon Hill PA'">301 Henderson Drive, Sharon Hill PA</option>
                                        <option :value="'Carr #2 KM-16.6 Suite 364, Toa Baja PR'">Carr #2 KM-16.6 Suite 364, Toa Baja PR</option>
                                        <option :value="'114 Minnesota Avenue, Unit 3, Warwick RI'">114 Minnesota Avenue, Unit 3, Warwick RI</option>
                                        <option :value="'205 Aberdeen Drive, Florence SC'">205 Aberdeen Drive, Florence SC</option>
                                        <option :value="'7 Idaho Street, Greenville SC'">7 Idaho Street, Greenville SC</option>
                                        <option :value="'404 East 40th Street North, Sioux Falls SD'">404 East 40th Street North, Sioux Falls SD</option>
                                        <option :value="'612 14th Avenue Southeast, Watertown SD'">612 14th Avenue Southeast, Watertown SD'</option>
                                        <option :value="'3740 Powers Court, Suite 400, Chattanooga TN'">3740 Powers Court, Suite 400, Chattanooga TN</option>
                                        <option :value="'2614 Brick Church Pike, Nashville TN'">2614 Brick Church Pike, Nashville TN</option>
                                        <option :value="'200 West Trinity Boulevard Grand Prairie TX'">200 West Trinity Boulevard Grand Prairie TX</option>
                                        <option :value="'1200 Silber Road, Houston TX'">1200 Silber Road, Houston TX</option>
                                        <option :value="'2377 South 1900 West, Ogden UT'">2377 South 1900 West, Ogden UT</option>
                                        <option :value="'1415 South 3600 West, Suite 200, Salt Lake City UT'">1415 South 3600 West, Suite 200, Salt Lake City UT</option>
                                        <option :value="'1220-D Fleetway Drive, Chesapeake VA'">1220-D Fleetway Drive, Chesapeake VA</option>
                                        <option :value="'9203 Burge Avenue, Richmond VA'">9203 Burge Avenue, Richmond VA</option>
                                        <option :value="'309 S Barre Road, Barre VT'">309 S Barre Road, Barre VT</option>
                                        <option :value="'9922 East Montgomery, Units 18 AND 19, Spokane Valley WA'">9922 East Montgomery, Units 18 AND 19, Spokane Valley WA</option>
                                        <option :value="'18436 Cascade Avenue South, Suite 160, Tukwila WA'">18436 Cascade Avenue South, Suite 160, Tukwila WA</option>
                                        <option :value="'2222 Nordale Drive, Appleton WI'">2222 Nordale Drive, Appleton WI</option>
                                        <option :value="'7130 Packer Drive, Wausau WI'">7130 Packer Drive, Wausau WI</option>
                                        <option :value="'215 15th Street, Huntington WV'">215 15th Street, Huntington WV</option>
                                        <option :value="'4200 1st Avenue, Suite 200, Nitro WV'">4200 1st Avenue, Suite 200, Nitro WV</option>
                                        <option :value="'5271 Hitt Boulevard, Gillette WY'">5271 Hitt Boulevard, Gillette WY</option>
                                        <option :value="'1130 Rockies Circle, Rock Springs WY'">1130 Rockies Circle, Rock Springs WY</option>
                                    </optgroup>
                                    <optgroup label="MWI Animal Health">
                                        <option :value="'4240 Hickory Lane, Sioux City IA'">4240 Hickory Lane, Sioux City IA</option>
                                        <option :value="'3041 West Pasadena Drive, Boise ID'">3041 West Pasadena Drive, Boise ID</option>
                                        <option :value="'1961 Premier Drive, Mankato MN'">1961 Premier Drive, Mankato MN</option>
                                        <option :value="'1018 South US 117 Highway, Warsaw NC'">1018 South US 117 Highway, Warsaw NC</option>
                                    </optgroup>
                                    <optgroup label="Nelsons Premix Service Incorporated">
                                        <option :value="'131 Old Creek Road, Storm Lake IA'">131 Old Creek Road, Storm Lake IA</option>
                                    </optgroup>
                                    <optgroup label="Northeast Agri Systems Incorporated">
                                        <option :value="'28527 Boyce Road, Laurel DE'">28527 Boyce Road, Laurel DE</option>
                                        <option :value="'139 West Airport Road, Lititz PA'">139 West Airport Road, Lititz PA</option>
                                        <option :value="'28435 General Thomas Highway, Franklin VA'">28435 General Thomas Highway, Franklin VA</option>
                                        <option :value="'4227 Lankford Highway, New Church VA'">4227 Lankford Highway, New Church VA</option>
                                    </optgroup>
                                    <optgroup label="Pals Inc.">
                                        <option :value="'3735 County Rd 5 West, Willmar MN'">3735 County Rd 5 West, Willmar MN</option>
                                    </optgroup>
                                    <optgroup label="Poultry Specialties, Inc.">
                                        <option :value="'3711 Industrial Drive, Broadway VA'">3711 Industrial Drive, Broadway VA</option>
                                        <option :value="'450 Main Street, Dayton VA'">450 Main Street, Dayton VA</option>
                                        <option :value="'230 Jefferson Street, Moorefield WV'">230 Jefferson Street, Moorefield WV</option>
                                    </optgroup>
                                    <optgroup label="Powell Feed - Imboden">
                                        <option :value="'5564 Highway 63 West, Imboden AR'">5564 Highway 63 West, Imboden AR</option>
                                    </optgroup>
                                    <optgroup label="Powell Feed - Lincoln">
                                        <option :value="'700 West Highway 62, Lincoln AR'">700 West Highway 62, Lincoln AR</option>
                                    </optgroup>
                                    <optgroup label="Powell Feed and Fertilizer">
                                        <option :value="'9095 Highway 62 East, Flippin AR'">9095 Highway 62 East, Flippin AR</option>
                                    </optgroup>
                                    <optgroup label="Powell Feed and Fuel">
                                        <option :value="'344 Highway 21 North, Berryville AR'">344 Highway 21 North, Berryville AR</option>
                                    </optgroup>
                                    <optgroup label="Powell Feed and Home">
                                        <option :value="'1629 East Main, Siloam Springs AR'">1629 East Main, Siloam Springs AR</option>
                                    </optgroup>
                                    <optgroup label="Powell Feed and Milling">
                                        <option :value="'181 West Main, Green Forest AR'">181 West Main, Green Forest AR</option>
                                    </optgroup>
                                    <optgroup label="Powell Home and Ranch">
                                        <option :value="'502 Highway 62 65 North, Harrison AR'">502 Highway 62 65 North, Harrison AR</option>
                                    </optgroup>
                                    <optgroup label="Powell's Hardware">
                                        <option :value="'#2 Park Drive, Holiday Island AR'">#2 Park Drive, Holiday Island AR</option>
                                    </optgroup>
                                    <optgroup label="Powell's Home and Ranch (Ace Hardware)">
                                        <option :value="'1107 South Main, Berryville AR'">1107 South Main, Berryville AR</option>
                                    </optgroup>
                                    <optgroup label="Preferred Poultry">
                                        <option :value="'2285 East Pridemore Drive, Lincoln AR'">2285 East Pridemore Drive, Lincoln AR</option>
                                        <option :value="'10019 Farm Road 2160, Cassville MO'">10019 Farm Road 2160, Cassville MO</option>
                                    </optgroup>
                                    <optgroup label="ProChaska, LLC">
                                        <option :value="'12502 Xenwood Avenue South, Savage MN'">12502 Xenwood Avenue South, Savage MN</option>
                                    </optgroup>
                                    <optgroup label="Pure Water, LLC">
                                        <option :value="'9768 Maumelle Boulevard, North Little Rock AR'">9768 Maumelle Boulevard, North Little Rock AR</option>
                                    </optgroup>
                                    <optgroup label="QC Supply">
                                        <option :value="'22357 Main Street Ranburne AL'">22357 Main Street Ranburne AL</option>
                                        <option :value="'800 South Phillips Street Algona IA'">800 South Phillips Street Algona IA</option>
                                        <option :value="'2205 East Lincoln Way Ames IA'">2205 East Lincoln Way Ames IA</option>
                                        <option :value="'907 Horizon Road Boyden IA'">907 Horizon Road Boyden IA</option>
                                        <option :value="'1222 West Marion Street Manchester IA'">1222 West Marion Street Manchester IA</option>
                                        <option :value="'113 Prairie Road Storm Lake IA'">113 Prairie Road Storm Lake IA</option>
                                        <option :value="'2492 Highway 92 Washington IA'">2492 Highway 92 Washington IA</option>
                                        <option :value="'1100 North Washington Street Delphi IN'">1100 North Washington Street Delphi IN</option>
                                        <option :value="'2631 New Bowling Green Road Glasgow KY'">2631 New Bowling Green Road Glasgow KY</option>
                                        <option :value="'3380 US Highway 431 North Livermore KY'">3380 US Highway 431 North Livermore KY</option>
                                        <option :value="'11741 US Highway 431 Utica KY'">11741 US Highway 431 Utica KY</option>
                                        <option :value="'9520 Highway 145 Downsville LA'">9520 Highway 145 Downsville LA</option>
                                        <option :value="'11191 US 14 Waseca MN'">11191 US 14 Waseca MN</option>
                                        <option :value="'4105 Highway US 12 East Willmar MN'">4105 Highway US 12 East Willmar MN</option>
                                        <option :value="'3803 Enterprise Drive Nevada MO'">3803 Enterprise Drive Nevada MO</option>
                                        <option :value="'1911 Speedway Drive Poplar Bluff MO'">1911 Speedway Drive Poplar Bluff MO</option>
                                        <option :value="'2700 South Limit Court Sedalia MO'">2700 South Limit Court Sedalia MO</option>
                                        <option :value="'1037 Highway 84 East Brookhaven MS'">1037 Highway 84 East Brookhaven MS</option>
                                        <option :value="'3906 Highway 49 North Collins MS'">3906 Highway 49 North Collins MS</option>
                                        <option :value="'1329 Highway 13 Columbia MS'">1329 Highway 13 Columbia MS</option>
                                        <option :value="'2633 Highway 35 South Forest MS'">2633 Highway 35 South Forest MS</option>
                                        <option :value="'113 Turner Street Waynesboro MS'">113 Turner Street Waynesboro MS</option>
                                        <option :value="'315 Industrial Drive Clinton NC'">315 Industrial Drive Clinton NC</option>
                                        <option :value="'574 Road 11 Schuyler NE'">574 Road 11 Schuyler NE </option>
                                        <option :value="'714 Northeast 6th Street Guymon OK'">714 Northeast 6th Street Guymon OK</option>
                                        <option :value="'1008 Airport Road Holdenville OK'">1008 Airport Road Holdenville OK</option>
                                        <option :value="'121 Malibu Drive Batesburg-Leesville SC'">121 Malibu Drive Batesburg-Leesville SC</option>
                                        <option :value="'1205 Industrial Park Road South Fulton TN'">1205 Industrial Park Road South Fulton TN</option>
                                    </optgroup>
                                    <optgroup label="Quality Ag Inc.">
                                        <option :value="'6385 196th Street, Albia IA'">6385 196th Street, Albia IA</option>
                                    </optgroup>
                                    <optgroup label="Reliable Poultry">
                                        <option :value="'1005 Venture Street, Green Forest AR'">1005 Venture Street, Green Forest AR</option>
                                        <option :value="'1724 West Center, Greenwood AR'">1724 West Center, Greenwood AR</option>
                                        <option :value="'9119 Highway 278 West, Nashville AR'">9119 Highway 278 West, Nashville AR</option>
                                        <option :value="'1629 East Main Street, Siloam Springs AR'">1629 East Main Street, Siloam Springs AR</option>
                                        <option :value="'2974 East Emma, Springdale AR'">2974 East Emma, Springdale AR</option>
                                        <option :value="'13991 Pennell Lane, Neosho MO'">13991 Pennell Lane, Neosho MO</option>
                                    </optgroup>
                                    <optgroup label="RFI Construction Products">
                                        <option :value="'495 Smith Street, Farmingdale NY'">495 Smith Street, Farmingdale NY</option>
                                    </optgroup>
                                    <optgroup label="Schlabach Equipment Inc.">
                                        <option :value="'2645 State Route 93, Sugarcreek OH'">2645 State Route 93, Sugarcreek OH</option>
                                    </optgroup>
                                    <optgroup label="Shenandoah Ag Supply">
                                        <option :value="'3101 John Wayland Highway, Dayton VA'">3101 John Wayland Highway, Dayton VA</option>
                                    </optgroup>
                                    <optgroup label="Smith Poultry Equipment">
                                        <option :value="'1516 S 4th Street, Nashville AR'">1516 S 4th Street, Nashville AR</option>
                                    </optgroup>
                                    <optgroup label="Spray Chem Chemical Company Inc.">
                                        <option :value="'705 Keenan Court, Durham CA'">705 Keenan Court, Durham CA</option>
                                    </optgroup>
                                    <optgroup label="Strand Ag Supply">
                                        <option :value="'5350 Esmar Road, Ceres CA'">5350 Esmar Road, Ceres CA</option>
                                    </optgroup>
                                    <optgroup label="Sunrise Equipment Company">
                                        <option :value="'5075 Navarre Road Southwest, Canton OH'">5075 Navarre Road Southwest, Canton OH</option>
                                    </optgroup>
                                    <optgroup label="The Schlueter Company">
                                        <option :value="'320 North Main Street, Janesville WI'">320 North Main Street, Janesville WI</option>
                                    </optgroup>
                                    <optgroup label="Top Line Equipment">
                                        <option :value="'405 North State Stree, Zeeland MI'">405 North State Stree, Zeeland MI</option>
                                    </optgroup>
                                    <optgroup label="Veterinary Service, Inc.">
                                        <option :value="'2892 South Orange Avenue, Fresno CA'">2892 South Orange Avenue, Fresno CA</option>
                                        <option :value="'4100 Bangs Avenue, Modesto CA'">4100 Bangs Avenue, Modesto CA</option>
                                        <option :value="'935 Palmyrita Avenue, Riverside CA'">935 Palmyrita Avenue, Riverside CA</option>
                                        <option :value="'1607 North Plaza Drive, Visalia CA'">1607 North Plaza Drive, Visalia CA</option>
                                        <option :value="'3700 Western Way Northeast, Albany OR'">3700 Western Way Northeast, Albany OR</option>
                                    </optgroup>
                                    <optgroup label="Zeiset Equipment LLC">
                                        <option :value="'2187 North Penryn Road, Manheim PA'">2187 North Penryn Road, Manheim PA</option>
                                    </optgroup>
                                </b-form-select>
                            
                            
                        </div>
                        <div class="col-sm-1 align-self-center">
                            <i class="fas fa-trash-alt" style="display:none" id="trash_0"></i>
                        </div>
                    </b-row>
                    </b-col>
                </b-form-row>
                <b-row>
                    <b-col class="col-lg-12" id="">
                    
                    <div class="col-sm-" style="margin-left: 0;">
                        <button id="addMore" type="button" class="btn" style="" @click="addUpload()"> + </button>
                    </div>
                    
                    </b-col>
                </b-row>
                <b-row align-h="center">
                   <b-col class="">
                         <b-button class="btn mx-auto" id="integrator"  @click="submit">SUBMIT</b-button>
                   </b-col>
                </b-row>
            </b-form>
        </b-col>
    </b-row>

    <!-- Bottom disclaimer -->
    <b-row>
        <b-col v-if="rebateType == 'Farmer'">
            <p> *In order to process your rebate, this form must be completed in its entirety and be accompanied by invoice(s) and/or receipt(s). Invoice(s) must show the date the Hydro AquaBlend Xtremes were purchased. No exceptions. Allow for 6-8 weeks from date of receipt at Hydro Rebate Headquarters for processing. Rebates will be executed as a check in the amount of $40.00 (forty) for each Hydro AquaBlend Xtreme purchased and will be issued to the purchaser as per the data provided on the online submission form. Max rebate amount of $400.00 allowed per purchaser. Promotion is open to USA and Canada residents only. All rebates are paid in USA dollars.</p>
        </b-col>
        <b-col v-if="rebateType == 'Integrator'">
            <p> *In order to process your rebate, this form must be completed in its entirety and be accompanied by invoice(s) and/or receipt(s). Invoice(s) must show the date the Hydro AquaBlend Xtremes were purchased. To qualify for redemption, you must be an employee of the company receiving the rebate offer. No exceptions. Allow for 6-8 weeks from date of receipt at Hydro Rebate Headquarters for processing. Rebates will be executed as a check in the amount $550.00 for every 12 Hydro AquaBlend Extremes purchased and will be made payable to the purchaser’s Company Name as per the data provided on the online submission form. Max rebate amount of $1,650.00 allowed. Promotion is open to USA and Canada residents only. All rebates are paid in USA dollars.</p>
        </b-col>
    </b-row>
    <b-row id="formAlert" class="alert-bottom alert alert-danger">
        
    </b-row>
</main>
</template>

<script>
// import "../../node_modules/@fortawesome/fontawesome-free/css/all.css"
import * as firebase from 'firebase';
import 'firebase/firestore';
// import { setTimeout } from 'timers';
// import 'nodep-date-input-polyfill';

export default {
  name: 'rebateFormEntry',
  data () {
    return {
      companyName: null,
      rebateType: null,
      firstName: null,
      lastName: null,
      email: null,
      phone: null,
      address1: null,
      address2: null,
      city: null,
      state: null,
      zip: null,
      country: null,
      submitType: null,
      uploadNumber: 0,
      invoiceData: null,
      baseImage: null,
      myDate: new Date().toISOString().slice(0,10),
      serverDateTime: new Date().getTime() / 1000,
      mail: null,
      imagePath: null,
      validateCount: 0,
      docID: null,
      browser: null
    }
  },
  beforeMount(){
      this.invoiceData = [];
  },
  mounted () {
      var vm = this;
    this.changeRebateType();

    // document.getElementById('phone').addEventListener('blur', function (e) {
    //     var x = e.target.value.replace(/\D/g, '').match(/(\d{3})(\d{3})(\d{4})/);
    //     e.target.value = '(' + x[1] + ') ' + x[2] + '-' + x[3];
    // });

    this.setInputFilter(document.getElementById("phone"), function(value) {
        return /^-?\d*$/.test(value);
    });
    this.setInputFilter(document.getElementById("firstName"), function(value) {
        return /^[a-z\u00c0-\u024f]*$/i.test(value);
    });
    this.setInputFilter(document.getElementById("lastName"), function(value) {
        return /^[a-z\u00c0-\u024f]*$/i.test(value);
    });

    document.getElementById('mail_0').onclick = function(){vm.disableUpload(0)};
  },
  methods: {
      changeRebateType() {
          // Get the modal
        var modal = document.getElementById("myModal");
        //start modal on load
        modal.style.display = "block";
      },
      setRebateType(type){
         try { 
          this.rebateType = type;

          document.getElementById("myModal").style.display = "none";
          return type;
         }
         catch (err) {
             return false;
         }
          
          
      },
      addUpload(){
        this.uploadNumber = this.uploadNumber + 1;
        
        //clone
        const vm = this;
        var fullRow = document.getElementById('invoiceRow_0');
        var parentRow = document.getElementById('invoiceUpload')
        var fullClone = fullRow.cloneNode(true)

        fullClone.innerHTML = fullClone.innerHTML.replace(/_0/g,'_' + this.uploadNumber);
        //append
        parentRow.appendChild(fullClone);
        fullClone.id = "invoiceRow_"+this.uploadNumber;
        var cloneRoot = fullClone.children[0];

        
        //file        
        var fileSpan = cloneRoot.children[0].children[0]
        var file = cloneRoot.children[0].children[0].children[1]
        document.getElementById('checkmark_'+this.uploadNumber).style.display = 'none';
        if(file.value != ""){
            file.value = "";
            
        }
        fileSpan.style.border = "0px solid red"
        fileSpan.onclick = function(event){ vm.checkStatus(event)};
        fileSpan.onchange = function(event){ vm.checkFile(event)};

        

        //mail in
        var mail = fullClone.children[0].children[1].children[0].children[0]
        var mailLabel = fullClone.children[0].children[1].children[0]
        mailLabel.htmlFor = "mail_"+this.uploadNumber;
        mail.checked = false
        fileSpan.classList.remove("disabled");
        
        mail.onclick = function(){
            if(mail.checked == true){
                fileSpan.classList.add("disabled");
            } else {
                fileSpan.classList.remove("disabled");
            }
            
        }
        
        
        //invoicenumber
        var invoiceNumber = fullClone.children[0].children[2].children[0]
        invoiceNumber.value = "";
        invoiceNumber.classList.remove('is-valid')
        invoiceNumber.classList.remove('is-invalid')

         //salesDate
         var salesDate = fullClone.children[0].children[3].children[0]
         salesDate.value = "";
         
         salesDate.classList.remove('is-valid')
         salesDate.classList.remove('is-invalid')

         salesDate.onblur = function(e){
             vm.checkDate(this.uploadNumber, salesDate.value);
         }


         //distributor
         var distributor = fullClone.children[0].children[4].children[0]
         distributor.value = "";

         distributor.classList.remove('is-valid')
         distributor.classList.remove('is-invalid')
        

        //delete row
        var trash = fullClone.children[0].children[5].children[0]
        
        trash.id = "trash_"+this.uploadNumber;
        trash.style.display = "block";
        
        trash.onclick = function(){
            let number = this.id.split("_");
            vm.delete(number[1])
            trash.style.display="none";
        };
        if(this.rebateType == 'Integrator'){
            if(this.uploadNumber >= 12) {
                document.getElementById('addMore').disabled = true;
            }
        } else {
            if(this.uploadNumber >= 9) {
                document.getElementById('addMore').disabled = true;
            }
        }
      },
      checkFile(e){
        var event = e.currentTarget;
        const fileId = event.children[0].id.split("_");
        const rowId = fileId[1];
        var uploadButton = document.getElementById('file_'+rowId);

        document.getElementById("mail_"+ rowId).disabled = true;
        document.getElementById("checkmark_" + rowId).style.display = (uploadButton.value ? "block" : "none");
        
      },
      disableUpload(uploadId){
          var uploadButton = document.getElementById('file_'+uploadId).parentElement;
          uploadButton.classList.toggle("disabled");
          
      },
    //   async getBase64(file) {
    //     return new Promise((resolve, reject) => {
    //         const reader = new FileReader();
    //         reader.readAsDataURL(file);
    //         reader.onload = () => resolve(reader.result);
    //         reader.onerror = error => reject(error);
    //     });
    //   },
    //   validateEmail(){
    //     if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(document.getElementById('email').value))
    //     {
    //         return true;
    //     }
    //         this.error('email')
    //         return false;
    //   },
      validateForm(formData){
          let vm = this;
          var inputArray = ["firstName", "lastName", "email", "phone", "address1", "city", "state", "zip", "country"];
          this.validateCount = 0;
          var i = 0;
            var r = 0;
          formData.forEach(input => {
              if(input.required === true){
                  r++
                  console.log('making it here')
                  
                  if(input.value) {
                    
                    switch(input.type){
                        case 'email': 
                            if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(input.value))
                            {   
                                i++
                                input.classList.add('is-valid')
                                input.classList.remove('is-invalid')
                                return true;
                            } else {
                                this.error(input.id);
                            }
                            break;
                        case 'tel':
                            if(input.value.length != 10){
                                this.error(input.id);
                                return;
                            } else {
                                i++
                                input.classList.add('is-valid')
                            }
                            break;
                        default:
                            if(input.dataset.type == "postal-code"){
                                var countryCode = formData.map( ( (keySearch) => (obj) => ( (!!obj.dataset ? (!!obj.dataset['type'] ? (obj.dataset['type'] == keySearch ? obj : undefined) : undefined) : undefined ) ) )('country-code')).filter(Boolean).shift()
                                
                                if(!countryCode.value){
                                    this.error(countryCode.id);
                                }
                                var postalCode = input.value;
                                
                                if(countryCode.value){
                                        switch (countryCode) {
                                            case "US":
                                                var postalCodeRegex = /(^\d{5}$)|(^\d{5}-\d{4}$)/;
                                                break;
                                            case "CA":
                                                var postalCodeRegex = /^([A-Z][0-9][A-Z])\s*([0-9][A-Z][0-9])$/;
                                                break;
                                            default:
                                                var postalCodeRegex = /(^\d{5}$)|(^\d{5}-\d{4}$)/;
                                        }
                                        if(!postalCodeRegex.test(postalCode)){
                                            this.error(input.id);
                                            this.error(countryCode.id);
                                            // return false;
                                        } else {
                                            i++
                                            input.classList.add('is-valid')
                                            countryCode.classList.add('is-valid')
                                            // return true;
                                        }
                                    }
                                } else {
                                    i++
                                    input.classList.add('is-valid')
                                    input.classList.remove('is-invalid')
                                }
                    }
                    
                    
                
                  } else {
                        this.error(input.id);
                  }
              }
          });
          this.validateCount = i;
          if(i == r){
            return true;
          } else {
              return false;
          }
      },
    //   checkPhone(){
    //       if(this.number.value.length != 14){
    //           this.error("phone")
    //       } else {
    //           document.getElementById(element).classList.add('is-valid')
    //           document.getElementById(element).classList.remove('is-invalid')
    //       }
    //   },
      setInputFilter(textbox, inputFilter) {
        ["input", "keydown", "keyup", "mousedown", "mouseup", "select", "contextmenu", "drop"].forEach(function(event) {
            textbox.oldValue = "";
            textbox.addEventListener(event, function() {
            if (inputFilter(this.value)) {
                this.oldValue = this.value;
                this.oldSelectionStart = this.selectionStart;
                this.oldSelectionEnd = this.selectionEnd;
            } else if (this.hasOwnProperty("oldValue")) {
                this.value = this.oldValue;
                this.setSelectionRange(this.oldSelectionStart, this.oldSelectionEnd);
            }
            });
        });
    },
      checkDate(rowID, date){
            var salesDate = document.getElementById("salesDate_"+rowID)
            var pickedDate = new Date(date)
             var beforeDate = new Date('2019-10-14')
             var afterDate = new Date('2019-12-31')
             
             var alert = document.getElementById('formAlert');

             if(pickedDate <= beforeDate){
                 salesDate.value = "2019-10-14";
                 
                salesDate.classList.add('is-invalid')
                alert.innerHTML = '<b-col col="12"><a href="#" class="close" data-dismiss="alert" aria-label="close">&times;</a> You can only enter Dates after 10/14/2019<b-col>'
                alert.style.display = "block";
                setTimeout(function(){
                    salesDate.classList.remove('is-invalid')
                    alert.style.display = "none"; 
                }, 6000);
                return false;
             } else if(pickedDate > afterDate){
                 salesDate.value = "2019-12-31";
                 return false;
             } else {
                return true; 
             }
      },
      error(name){
          var input = document.getElementById(name);
          var alert = document.getElementById('formAlert');
        
          var fixedName = name.split('_');
          var spacedName = fixedName[0].split(/(?=[A-Z])/);

          if(spacedName.length == 2){
              var propName = spacedName[0].charAt(0).toUpperCase() + spacedName[0].slice(1) + " " + spacedName[1].charAt(0).toUpperCase() + spacedName[1].slice(1);
          } else {
              var length = spacedName[0].length
              var sliceName = spacedName[0].slice(0, 1);
              var propName = sliceName.charAt(0).toUpperCase() + spacedName[0].slice(1);
          }
          //console.log(input)
          if(name.includes('file_')){
              input.parentElement.style.border = "3px solid red"
              alert.innerHTML = '<b-col col="12"><a href="#" class="close" data-dismiss="alert" aria-label="close">&times;</a> Please upload a valid image or select the mail in option.<b-col>'
            setTimeout(function(){
                input.parentElement.style.border = "0px solid red"
            }, 6000);
          } else {
              alert.innerHTML = '<b-col col="12"><a href="#" class="close" data-dismiss="alert" aria-label="close">&times;</a>Please Enter Valid '+ propName +'<b-col>'
              input.classList.add('is-invalid')
          }
          
            alert.style.display = "block";
            setTimeout(function(){
                alert.style.display = "none"; 
            }, 6000);
      },
      
      submit(){
          var x = Object.values( document.getElementById('rebateForm') )
          
          var valid = this.validateForm(x);
        if(valid == false){
            return false;
        }

        const vm = this;
        this.empty();
        this.store(function(c){
                    for(var p = 0; p < 12; p++){
                        if(!document.getElementById("invoiceRow_"+p)){
                            continue;
                        }
                        var salesDate = document.getElementById("salesDate_"+p).value;
                        
                        var invoiceNumber = document.getElementById("invoiceNumber_"+p).value;
                        
                        var distributor = document.getElementById("distributor_"+p).value;
                        
                        var checkbox = document.getElementById('mail_'+p);
                        
                        if(checkbox.checked == true) {
                            var invoiceName = "mail in"
                            vm.storeInvoiceData(c, invoiceName, invoiceNumber, salesDate, distributor);
                        } else {
                            if(!document.getElementById('file_'+p).value){
                            vm.error("file_"+p)
                            return;
                        }
                        var invoiceName = document.getElementById('file_' + p).files[0].name


                        vm.storeInvoiceData(c, invoiceName, invoiceNumber, salesDate, distributor);


                        vm.storeImg(document.getElementById('file_' + p), c);
                                
                        } 
                    }
          vm.$router.replace({ path: 'confirmation', query: {docID: c}})
        });

        return true;
      },
    
      storeInvoiceData(docId, invoiceName, invoiceNumber, salesDate, distributor){
          var vm = this;
           firebase
                .firestore()
                .collection("invoices")
                .add({
                    "refKey": docId,
                    "invoiceNumber": invoiceNumber,
                    "invoiceName": invoiceName,
                    "salesDate": salesDate,
                    "distributor": distributor,
                    "status": "PENDING"
                })
                .then(function (docRef){
                    this.$router.replace({ path: 'confirmation', query: {docID: docId}})
                })
                .catch(function (error) {
                    console.error(error)
                })
      },
      store(cb){
          var vm = this;
           firebase
                .firestore()
                .collection("submissions")
                .add({
                    "firstName": this.$data.firstName,
                    "lastName": this.$data.lastName,
                    "email": this.$data.email,
                    "phone": this.$data.phone,
                    "address1": this.$data.address1,
                    "address2": this.$data.address2,
                    "city": this.$data.city,
                    "state": this.$data.state,
                    "zip": this.$data.zip,
                    "country": this.$data.country,
                    "type":this.$data.rebateType,
                    "entryDate":this.$data.serverDateTime,
                    "companyName":this.$data.companyName
                })
                .then(function (docRef){
                    cb(docRef.id);
                })
                .catch(function (error) {
                    console.error(error)
                })
      },
      empty(){
          this.invoiceData.length = 0;
      },
      delete(number){
          
        var invoiceFileNode = document.getElementById('file_' + number)
        var elem = invoiceFileNode.parentElement.parentElement.parentElement.parentNode;
        elem.parentElement.removeChild(elem);
        
        this.uploadNumber = this.uploadNumber - 1;
        if(this.rebateType == 'Integrator'){
            if(this.uploadNumber >= 12) {
                document.getElementById('addMore').disabled = true;
            } else {
                document.getElementById('addMore').disabled = false;
            }
        } else {
            if(this.uploadNumber >= 9) {
                document.getElementById('addMore').disabled = true;
            } else {
                document.getElementById('addMore').disabled = false;
            }
        }    
      },
      checkStatus(e) {
        var event = e.currentTarget;
        const fileId = event.children[0].id.split("_");
        const rowId = fileId[1];
        var checkbox = document.getElementById('mail_'+rowId);
        var uploadButton = document.getElementById('file_'+rowId);
        if (checkbox.checked == true){
            e.preventDefault();
            
        }
      },
      storeImg(image, docID) {
          var imageFile = image.files[0]
            var storage = firebase.storage();
            var storageRef = storage.ref();

            // Create a child reference
            var imagesRef = storageRef.child('images');

            var spaceRef = storageRef.child("invoice/"+ docID+"/"+image.value);

            var path = spaceRef.fullPath
            this.imagePath = path;
            if (typeof FileReader === 'function') {
                const reader = new FileReader()

                reader.onload = (event, callback) => {
                this.imgSrc = event.target.result
                var image = this.imgSrc;
                
                spaceRef.putString(image, 'data_url').then(function(snapshot) {
                });
                    
                }
                reader.readAsDataURL(imageFile)
            }
      },
      deleteFirestoreEntry(docId){
           firebase
                .firestore()
                .collection("submissions")
                .doc(docId)
                .delete()
                .then(function (docRef){
                })
                .catch(function (error) {
                    console.error(error)
                })
      },
      isValidPostalCode() {
          
          var countryCode = document.getElementById('country').value;
          var postalCode = document.getElementById('zip').value;
          
          if(countryCode){
                switch (countryCode) {
                    case "US":
                        var postalCodeRegex = /(^\d{5}$)|(^\d{5}-\d{4}$)/;
                        break;
                    case "CA":
                        var postalCodeRegex = /^([A-Z][0-9][A-Z])\s*([0-9][A-Z][0-9])$/;
                        break;
                    default:
                        var postalCodeRegex = /(^\d{5}$)|(^\d{5}-\d{4}$)/;
                }
                if(!postalCodeRegex.test(postalCode)){
                    this.error('zip');
                    document.getElementById('country').classList.add('is-invalid')
                    return false;
                } else {
                    document.getElementById('zip').classList.remove('is-invalid')
                    document.getElementById('country').classList.remove('is-invalid')
                    document.getElementById('zip').classList.add('is-valid')
                    document.getElementById('country').classList.add('is-valid')
                    return true;
                }
            } 
      }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/rebateFormEntry.vue